/* eslint-disable no-lonely-if */
import { DURATION_FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';
import { getParamsDelimiter } from '@aibees/elephant/feature/search-filters/components/filter-tags/utils';
import { SearchFilterType } from '@aibees/elephant/feature/search-filters/types';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';

export function buildDraft(
  params: Partial<SearchBrowseParams>,
  type: SearchFilterType,
  field: string,
  action: 'remove' | 'add' | 'clear',
  index?: number,
  value?: string,
  paramsValue?: string
) {
  const separator = getParamsDelimiter(type);

  const current: Maybe<string>[] =
    paramsValue || params[field]
      ? (paramsValue ?? (params[field] as string)).split(separator)
      : [];

  const isRange =
    type === SearchFilterType.DATE_RANGE ||
    type === SearchFilterType.NUMBER_RANGE ||
    type === SearchFilterType.DURATION;

  if ((isRange || action === 'remove') && typeof index === 'undefined') return;

  if (action === 'clear') return undefined;

  if (isRange) {
    if (action === 'remove') {
      if (current.length) {
        current[index!] = undefined;
      }
      if (
        current.every(
          (x) =>
            x === undefined ||
            x.length === 0 ||
            x === DURATION_FILTER_VALUE_SEPARATOR
        )
      )
        return undefined;
    } else {
      if (current.length) {
        current[index!] = value;
      } else {
        current[index!] = value;
      }
      if (current.every((x) => x === undefined || x.length === 0))
        return undefined;
    }
  } else {
    if (action === 'remove') {
      current.splice(index!, 1);
    } else {
      current.push(value);
    }
    if (!current.length) return undefined;
  }
  return current.join(separator);
}
